import { render, staticRenderFns } from "./ReportEmpty.vue?vue&type=template&id=4b352052&"
import script from "./ReportEmpty.vue?vue&type=script&lang=js&"
export * from "./ReportEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports